import gql from 'graphql-tag'

export default gql`
  mutation updateSignaturePoints($points: String!, $socketId: String, $width: Number) {
    updateSignaturePoints(points: $points, socketId: $socketId, width: $width) @client
  }
`
